import { Paper } from "@mui/material";
import { ErrorBoundary } from "@components/index";
import useLoginPageData from "./loginPageData";
import LoginBranding from "./components/LoginBranding";
import LoginHeader from "./components/LoginHeader";
import LoginFooter from "./components/LoginFooter";
import CredentialsStep from "./components/CredentialsStep";
import OTPStep from "./components/OTPStep";

import "./index.scss";

const LoginPage = () => {
  const {
    step,
    formData,
    errors,
    loading,
    errorMessage,
    handleChange,
    handleCredentialsSubmit,
    handleOTPSubmit,
    handleResendOTP,
    handleBackToLogin,
    passwordVisibilityData,
  } = useLoginPageData();

  return (
    <div className="login-page">
      <ErrorBoundary>
        <div className="login-left">
          <LoginBranding />
        </div>
      </ErrorBoundary>

      <ErrorBoundary>
        <div className="login-right">
          <Paper className="login-card" elevation={0}>
            <LoginHeader step={step} />

            {step === "credentials" ? (
              <ErrorBoundary>
                <CredentialsStep
                  formData={formData}
                  errors={errors}
                  loading={loading}
                  loginCredsError={errorMessage}
                  handleChange={handleChange}
                  handleSubmit={handleCredentialsSubmit}
                  passwordVisibilityData={passwordVisibilityData}
                />
              </ErrorBoundary>
            ) : (
              <ErrorBoundary>
                <OTPStep
                  formData={formData}
                  otpError={errorMessage}
                  loading={loading}
                  handleChange={handleChange}
                  handleSubmit={handleOTPSubmit}
                  handleResend={handleResendOTP}
                  handleBack={handleBackToLogin}
                />
              </ErrorBoundary>
            )}
          </Paper>

          <LoginFooter />
        </div>
      </ErrorBoundary>
    </div>
  );
};

export default LoginPage;
